// extracted by mini-css-extract-plugin
export default {"base":"Card_base__7yfXv","primary":"Card_primary__eeY32","uhc":"Card_uhc__YNdBy"};